import { createStore } from 'owa-satcheljs';
import type { ActionButtonState, ActionButtonStateByMailboxInfo } from './schema/ActionButtonState';
import type { AccountKey } from 'owa-client-types';

const joinButtonStore: () => ActionButtonStateByMailboxInfo =
    createStore<ActionButtonStateByMailboxInfo>('joinButtonStore', {
        groupActionStateByMailboxInfo: new Map<AccountKey, ActionButtonState>(),
    });

export default joinButtonStore;
